module.exports = __webpack_public_path__ + "media/slide4/contractMediaSlide4Part2-6eccface.png";